import { hslToHex } from "~/utils";

const GOLDEN_ANGLE = 137.508;

const hashString = (str: string) => {
    let hash = 0;

    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0;
    }

    return Math.abs(hash);
};

const idToColor = (id: string) => {
    const hash = hashString(id);
    const hue = (hash * GOLDEN_ANGLE) % 360;
    const saturation = 60 + (hash % 20);
    const lightness = 50 + (hash % 10);

    return hslToHex(hue, saturation, lightness);
};

export const getColorFor = (entity: string, id: string) => {
    return idToColor(id);
};

export const DAY_COLORS = {
    yellow: "#d7d704",
    green: "#85a553",
    gray: "#8e8f8f",
    red: "#ff7448",
};

export const TIME_COLORS = {
    contracted: "#e0e0e0",
    tracked: "#bae1ff",
    reported: "#acdb69",
    overReported: "#77a83d",
};

// @LINK Ocr colors
const RED = "#ff7448";
const GREEN = "#22c55e";
const YELLOW = "#fcbe03";

const COLOR_THRESHOLDS = [
    {
        level: "red",
        color: RED,
        threshold: 0.6,
    },
    {
        level: "yellow",
        color: YELLOW,
        threshold: 0.9,
    },
    {
        level: "green",
        color: GREEN,
        threshold: 1,
    },
] as const;

export const getOcrColor = (score: number) =>
    COLOR_THRESHOLDS.find(({ threshold }) => score <= threshold)?.color || RED;

export const getOcrLevel = (score: number) =>
    COLOR_THRESHOLDS.find(({ threshold }) => score <= threshold)?.level ||
    "red";

export const getOcrColorByLevel = (level: string) =>
    COLOR_THRESHOLDS.find(({ level: l }) => l === level)?.color || RED;
